import React, { useEffect, useState, useMemo, useRef, useImperativeHandle } from "react";
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { toast } from 'react-toastify';
import Modal from "react-modal";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import FTUVehicleData from "./FTUVehicleData";
import Spinner from "../../common/Spinner/Spinner";
import { Button } from "../../common/Button/Button";
import {
  Table, TableBody, TableCell,
  TableHead, TableRow, Paper, Typography,
  TableContainer,
  TableFooter
} from '@material-ui/core';
import api from "../../utils/api";
import '../../styles/_PartnerData.scss';

const DreamBigProgramManagerEntryPointGrid = (props) => {
  const [expandedPartner, setExpandedPartner] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [resourcesData, setResourcesData] = useState([]);
  const [sortBy, setSortBy] = useState('');
  const [ftuVehicleQuestionCount, setFtuVehicleQuestionCount] = useState([])
  const [ftuDeviceCount, setFtuDeviceCount] = useState([])
  const [vehicleDeviceCombination, setVehicleDeviceCombination] = useState([]);
  const [vehicleDeviceCombinationFilterData, setVehicleDeviceCombinationFilterData] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([])
  const [deviceOptions, setDeviceOptions] = useState([])
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [firstTimePartnerResourceData, setFirstTimePartnerResourceData] = useState([])
  const [engagedPartnerResourceData, setEngagedPartnerResourceData] = useState([])
  const [selectedOptionsMergedPartnerResource, setSelectedOptionsMergedPartnerResource] = useState([]);
  const [selectedOptionsMergedPartnerResourceEu, setSelectedOptionsMergedPartnerResourceEu] = useState([]);
  const [isFirstUsertableLoading, setIsFirstTableUserLoading] = useState(true);
  const [isVehicleDeviceLoading, setIsVehicleDeviceLoading] = useState(false);
  const [isVehicleDeviceTypeFilterOpen, setIsVehicleDeviceTypeFilterOpen] = useState(false);
  const [selectedOptionsVehicleType, setSelectedOptionsVehicleType] = useState([]);
  const [selectedOptionsDeviceType, setSelectedOptionsDeviceType] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [search, setSearch] = useState(false)
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  const syncScroll = (e) => {
    if (leftRef.current && rightRef.current) {
      leftRef.current.scrollTop = e.target.scrollTop;
    }
  };




  const handleVehicleDeviceFilterOpen = () => {
    setIsVehicleDeviceTypeFilterOpen(!isVehicleDeviceTypeFilterOpen)
  }



  const gridRef = useRef();
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const dateAdjusted1 = (date) => {
    let toDateAdjusted;
    if (date) {
        toDateAdjusted = new Date(date);

        toDateAdjusted = new Date(
            toDateAdjusted.setTime(
                // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
                toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
            )
        );
    }
    return toDateAdjusted;
}

  const getFTCVehicleData = () => {
    getVehicleTypes();
    if (props.selectedProgramManager?.value) {
      setVehicleDeviceCombinationFilterData([])
      const params = { sProgramManager: props.selectedProgramManager?.value }
      if (props.fromDate && props.toDate) {
        const originalDate = new Date(props.toDate);
        originalDate.setUTCDate(originalDate.getUTCDate() + 1);
        const newDateStr = originalDate.toISOString();
        
        params.fromDate = dateAdjusted1(props.fromDate);
        params.toDate = dateAdjusted1(newDateStr);
    }
      api.getVehicleData(params).then((res) => {
        if (res) {
          console.log('res:::',res)
          setVehicleDeviceCombinationFilterData(res.data)
        }
      })
    }
  }

  const getVehicleTypes = () => {
    const filterParameters = { sProgramManager: props.selectedProgramManager?.value }
    if (filterParameters) {
      const { tempDreamBigVehicleDeviceCombinationCount } = api.getDreamBigVehicleDeviceCombinationCount(filterParameters)
        .then(({ data }) => {
          if (data) {

            const uniqueVehicle = {};
            const uniqueDevice = {};

            for (let elem of data) {
              const vehicle = elem.vehicle ? elem.vehicle : "Not Provided";
              const device = elem.device ? elem.device : "Not Provided";

              if (uniqueVehicle[vehicle]) {
                uniqueVehicle[vehicle]++;
              } else {
                uniqueVehicle[vehicle] = 1;
              }

              if (uniqueDevice[device]) {
                uniqueDevice[device]++;
              } else {
                uniqueDevice[device] = 1;
              }
            }

            let allUniqueVehicle = Object.keys(uniqueVehicle);
            let allUniqueDevice = Object.keys(uniqueDevice);




            let formatedVehicleOption = allUniqueVehicle.map((val) => {
              return {
                label: val !== "Not Provided" ? val : "Not Provided",
                value: val !== "Not Provided" ? val : null,
              }
            })

            let formatedDeviceOption = allUniqueDevice.map((val) => {
              return {
                label: val !== "Not Provided" ? val : "Not Provided",
                value: val !== "Not Provided" ? val : null,
              }
            })

            let formattedData = data.map((obj) => {
              if (!obj.vehicle) {
                obj.vehicle = "Not Provided"
              }

              if (!obj.device) {
                obj.device = "Not Provided"
              }

              return obj;
            })

            let sortedFormattedData = formattedData.sort((a, b) => {
              const vehicleA = a.vehicle?.toLowerCase() || "";
              const vehicleB = b.vehicle?.toLowerCase() || "";
              return vehicleA.localeCompare(vehicleB);
            })


            setVehicleOptions(formatedVehicleOption);
          } else {
            toast("", {
              autoClose: 5000,
              type: toast.TYPE.ERROR,
            })
          }
        }).catch((error) => {
          if (error.response.data.detail !== "Authentication credentials were not provided.") {
            toast(String(error.response.data.detail), {
              autoClose: 5000,
              type: toast.TYPE.ERROR,
            });
          } else if (error.response.data.message) {
            toast(String(error.response.data.message), {
              autoClose: 5000,
              type: toast.TYPE.ERROR,
            });
          }
        }).finally(() => {
          // setIsFirstTableUserLoading(false);
        })
    }

  }



  useEffect(() => {
    handleClearVehicleDeviceFilter();
  }, [props.isClearClicked])

  useImperativeHandle(props.clearRef, () => ({
    handleClearVehicleDeviceFilter,  // No parentheses — just pass the function reference
  }));
  // useImperativeHandle(props.searchRef, () => ({
  //   handleSearchClick,  // No parentheses — just pass the function reference
  // }));

  // const handleSearchClick=()=>{
  //   setSearch(true)
  // }

  useEffect(() => {
    let isMounted = true; // For memory leak prevention

    const processDataAndSetRows = async () => {
      await getFTCVehicleData(); // Your existing data fetching

      if (!isMounted) return; // Prevent state update on unmounted component

      if (!props.pmData || props.pmData.length === 0) {
        setRowData([]);
        return;
      }

      const [field, direction] = sortBy?.split("|") || [];
      const isAsc = direction === "asc";


      const getOverallItemCount = (item) => {
        if (!item) return 0;

        if (field === "typeOfVehicle") {
          return Object.values(item.vehicleBreakdown || {}).reduce((sum, val) => sum + (Number(val) || 0), 0);
        }
        if (field === "resourcesAvailed") {
          return (item.sSourceCounts || []).reduce((sum, obj) => sum + (Number(obj?.count) || 0), 0);
        }
        return 0;
      };

      const initialSortedPmData = [...(props.pmData || [])]
        .filter(item => item != null) // Remove any null/undefined entries
        .map((item, index) => ({ item, index })) // Store original index for stable sort
        .sort((a, b) => {
          const countA = getOverallItemCount(a.item);
          const countB = getOverallItemCount(b.item);
          return countA === countB
            ? a.index - b.index // Stable sort for equal counts
            : isAsc
              ? countA - countB
              : countB - countA;
        })
        .map(({ item }) => item); // Get back the original item

      const groupedMap = new Map();

      initialSortedPmData.forEach((item) => {
        const programManagerName = item.sProgramManager;
        const ftcValue = item.FTC || 0;
        const partnerName = item.sEntryPoint || '';

        let resources = (item.sSourceCounts || []).map((src) => ({
          label: src.sResourceDisplayName,
          count: src.count,
        }));

        if (field === "resourcesAvailed") {
          resources.sort((a, b) => isAsc ? (Number(a.count) || 0) - (Number(b.count) || 0) : (Number(b.count) || 0) - (Number(a.count) || 0));
        }

        let vehicleBreakdownArray = Object.entries(item.vehicleBreakdown || {}).map(([type, count]) => ({ type, count }));
        if (field === "typeOfVehicle") {
          vehicleBreakdownArray.sort((a, b) => isAsc ? (Number(a.count) || 0) - (Number(b.count) || 0) : (Number(b.count) || 0) - (Number(a.count) || 0));
        }


        // Get or create the program manager group
        if (!groupedMap.has(programManagerName)) {
          groupedMap.set(programManagerName, {
            programManager: programManagerName,
            ftc: 0, // Will be aggregated
            partners: [],
            totalResources: 0,
            totalVehicles: 0
          });
        }

        const pmGroup = groupedMap.get(programManagerName);
        pmGroup.ftc += ftcValue; // Aggregate FTC for the program manager

        pmGroup.totalResources += resources.reduce((sum, res) => sum + (Number(res.count) || 0), 0);
        pmGroup.totalVehicles += vehicleBreakdownArray.reduce((sum, veh) => sum + (Number(veh.count) || 0), 0);

        pmGroup.partners.push({
          partner: partnerName,
          resources: resources,
          vehicleBreakdown: vehicleBreakdownArray
        });
      });

      let finalGroupedData = Array.from(groupedMap.values());

      if (field === "resourcesAvailed" || field === "typeOfVehicle") { // If sorting PMs by their totals
        finalGroupedData.sort((a, b) => {
          const countA = field === "resourcesAvailed" ? a.totalResources : a.totalVehicles;
          const countB = field === "resourcesAvailed" ? b.totalResources : b.totalVehicles;
          return isAsc ? countA - countB : countB - countA;
        });
      }


      finalGroupedData.forEach(pmGroup => {
        pmGroup.partners.sort((a, b) => a.partner.localeCompare(b.partner));

        if (field === "resourcesAvailed") {
          pmGroup.partners.sort((a, b) => {
            const totalA = a.resources.reduce((sum, res) => sum + (Number(res.count) || 0), 0);
            const totalB = b.resources.reduce((sum, res) => sum + (Number(res.count) || 0), 0);
            return isAsc ? totalA - totalB : totalB - totalA;
          });
        }
      });


      if (isMounted) {
        setRowData(finalGroupedData);
        console.log('transformData Final Grouped Data:', finalGroupedData);
        console.log('transformData::',transformData(props.pmData))
      }
    };

    processDataAndSetRows();

    return () => {
      isMounted = false;
    };
  }, [sortBy, props.pmData, props.fromDate, props.toDate]);

  const transformData = (data) => {
    const grouped = {};
  
    data.forEach(entry => {
      const managers = entry.sProgramManager.split(',');
      managers.forEach(manager => {
        if (!grouped[manager]) {
          grouped[manager] = {
            programManager: manager,
            ftc: 0,
            partners: []
          };
        }
  
        grouped[manager].ftc += entry.FTC;
  
        grouped[manager].partners.push({
          partner: entry.sEntryPoint,
          resources: entry.sSourceCounts.map(src => ({
            label: src.sResourceDisplayName,
            count: src.count
          }))
        });
      });
    });
  
    return Object.values(grouped);
  };



  const handleClearVehicleDeviceFilter = () => {
    setSelectedVehicle(null);
    setSelectedDevice(null);
    setIsFilterActive(false);
    setIsVehicleDeviceTypeFilterOpen(false)
    setVehicleDeviceCombinationFilterData([])
    setSelectedOptionsVehicleType([]);
    setSelectedOptionsDeviceType([])
    setTimeout(()=>{
        getFTCVehicleData();
    },2000)

  }

  const handleVehicleDeviceCombinationSearch = async () => {


    setIsVehicleDeviceLoading(true)
    setIsVehicleDeviceTypeFilterOpen(false);

    try {
      setIsFilterActive(true);

      const filterParameters = { sProgramManager: props.selectedProgramManager.value };

      if (selectedOptionsVehicleType.length > 0) {
        filterParameters.vehicle_type = selectedOptionsVehicleType.map(opt => opt.value);
      }



      const { data } = await api.getVehicleData(filterParameters);
      if (data) {
        setVehicleDeviceCombinationFilterData(data);
      } else {
        toast("No data found", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
        });
      }
    } catch (error) {
      const detail = error?.response?.data?.detail;
      const message = error?.response?.data?.message;
      if (detail && detail !== "Authentication credentials were not provided.") {
        toast(String(detail), { autoClose: 5000, type: toast.TYPE.ERROR });
      } else if (message) {
        toast(String(message), { autoClose: 5000, type: toast.TYPE.ERROR });
      }
    } finally {
      setIsVehicleDeviceLoading(false)
    }

  }

  const handleMultipleVehicleSelect = (selected) => {
    setSelectedOptionsVehicleType(selected)
  }

  const handleMultipleDeviceSelect = (selected) => {
    setSelectedOptionsDeviceType(selected)
  }




  useEffect(() => {
    if (props.selectedPartnerName && props.resourceDataSelectedPartner) {
      setResourcesData(props.resourceDataSelectedPartner);
    } else {
      setResourcesData([]);
    }
  }, [props.selectedPartnerName, props.resourceDataSelectedPartner]);

  const handlePartnerClick = (partner) => {
    const partnerName = partner.partner;
    props.setSelectedPartnerName(partnerName);
    setExpandedPartner(expandedPartner === partnerName ? null : partnerName);

    if (expandedPartner !== partnerName) {
      props.getResourceDataForSelectedPartner(
        props.selectedProgramManager?.value,
        partnerName
      );
    } else {
      setResourcesData([]);
    }
  };



  const footerRow = {
    programManager: "Total",
    ftc: "Total : " + rowData?.reduce((total, row) => {
      const ftc = row?.ftc;
      if (typeof ftc === 'number') {
        return total + ftc;
      }
      const num = Number(ftc);
      if (!isNaN(num)) {
        return total + num;
      }

      const digits = ftc?.toString().split('').map(Number).filter(n => !isNaN(n));
      return total + digits.reduce((a, b) => a + b, 0);
    }, 0),
    resourcesAvailed: `Total : ${rowData.reduce((sum, row) => {
      if (row.resourcesAvailed && row.resourcesAvailed.includes(":")) {
        const [, countStr] = row.resourcesAvailed.split(":");
        const count = parseInt(countStr.trim(), 10);
        return sum + (isNaN(count) ? 0 : count);
      }
      return sum;
    }, 0)}`
  };


  const columnStyles = {
    programManager: { width: '20%' },
    partner: { width: '25%' },
    ftc: { width: '15%' },
    resources: { width: '40%' },
    ftc1: { width: '15%' },
    resources2: { width: '41%' },
  };



  // --- No Data Template ---
  const overlayNoRowsTemplate = rowData.length === 0
    ? '<span class="ag-overlay-no-rows-center">No data available</span>'
    : '<span class="ag-overlay-no-rows-center">Loading...</span>';



  return (
<div className="partner-data-container">
      {props.selectedsEntryPoint && props.selectedsEntryPoint.length > 0 && (
        <div>
          <div className="header-section">
            <h3 className="spled-colored-label">
              Partner Data for Program Manager
            </h3>
            <div className="sort-by-section">
              <label>Sort By:</label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="">-- Select --</option>
                <option value="resourcesAvailed|asc">Resources Availed (Low to High)</option>
                <option value="resourcesAvailed|desc">Resources Availed (High to Low)</option>
              </select>
            </div>
          </div>
          {rowData.length === 0 ? (
            <div className="no-data-table-container">
              <table>
                <thead>
                  <tr>
                    <th>Program Manager</th>
                    <th style={{ textAlign: 'right' }}>FTCs</th>
                    <th>Partner</th>
                    <th>Resources Availed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="4">
                      No data available
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <div className="data-table-container">
              <div className="table-scroll-area">
                <table>
                  <thead className="sticky-header">
                    <tr>
                      <th className="pm-col">Program Manager</th>
                      <th className="ftc-col">FTCs</th>
                      <th className="partner-col">Partner</th>
                      <th className="resources-col">Resources Availed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rowData.map((pm, pmIndex) => {
                      const totalResourceRows = pm.partners.reduce((acc, partner) => acc + partner.resources.length, 0);
                      let rowIndex = 0;

                      return pm.partners.map((partner, partnerIndex) =>
                        partner.resources.map((res, resIndex) => {
                          const showProgramManager = rowIndex === 0;
                          const showPartner = resIndex === 0;

                          const row = (
                            <tr key={`${pmIndex}-${partnerIndex}-${resIndex}`}>
                              {showProgramManager && (
                                <>
                                  <td rowSpan={totalResourceRows} className="pm-cell">
                                    {pm.programManager}
                                  </td>
                                  <td rowSpan={totalResourceRows} className="ftc-cell">
                                    {pm.ftc}
                                  </td>
                                </>
                              )}
                              {showPartner && (
                                <td rowSpan={partner.resources.length} className="partner-cell">
                                  {partner.partner}
                                </td>
                              )}
                              <td className="resource-cell">{res.label}: {res.count}</td>
                            </tr>
                          );

                          rowIndex++;
                          return row;
                        })
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {rowData.length > 0 && (
                <div className="sticky-footer">
                  <table>
                    <tfoot>
                      <tr>
                        <td className="pm-col"></td>
                        <td className="ftc-col"></td>
                        <td className="partner-col"></td>
                        <td className="total-cell">
                          Total: {rowData.reduce((total, pm) => total + (pm.ftc || 0), 0)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          )}

          <div className="row mt-3 mb-3">
            <div className={`col-12 ${isVehicleDeviceLoading ? "set-opacity" : ""}`}>
              {isVehicleDeviceLoading && <Spinner className="center" />}
              <FTUVehicleData
                ftuVehicleQuestionCount={ftuVehicleQuestionCount}
                ftuDeviceCount={ftuDeviceCount}
                vehicleDeviceCombination={vehicleDeviceCombination}
                vehicleOptions={vehicleOptions}
                deviceOptions={deviceOptions}
                vehicleDeviceCombinationFilterData={vehicleDeviceCombinationFilterData}
                isFilterActive={isFilterActive}
                firstTimeData={firstTimePartnerResourceData}
                engagedData={engagedPartnerResourceData}
                selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource}
                setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource}
                selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu}
                setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu}
                isFirstUsertableLoading={isFirstUsertableLoading}
                selectedProgramManager={props.selectedProgramManager}
                handleVehicleDeviceFilterOpen={handleVehicleDeviceFilterOpen}
              />
            </div>
          </div>
        </div>
      )}
      <Modal isOpen={isVehicleDeviceTypeFilterOpen}>
        <ModalContent className="dreambig-device-vehicle-filter-modal">
          <div className="modal-header">
            <span className="modal-title">Filters</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={() => setIsVehicleDeviceTypeFilterOpen(false)}
            />
          </div>

          <div className="modal-body">
            <div>
              <div className='mt-0 mb-3 p-2'>
                <div className="modal-filter-content-area">
                  <div className="row filter-row">
                    <div className="col-6 mt-2 spled-container">
                      <ReactMultiSelectCheckboxes
                        options={vehicleOptions}
                        placeholderButtonLabel="Select Vehicle Type"
                        value={selectedOptionsVehicleType}
                        onChange={handleMultipleVehicleSelect}
                      />
                    </div>
                  </div>

                  <div className="row filter-row">
                    <div className="col-12 mt-5 spled-container mt-6 filter-buttons-container" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>
                      <Button onClick={handleClearVehicleDeviceFilter}>Clear All</Button>
                      <Button onClick={handleVehicleDeviceCombinationSearch}>Search</Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default DreamBigProgramManagerEntryPointGrid;



